<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <h1 class="title">Storage Medications & Equipment</h1>
      <app-cells><h2 class="title">Medications</h2></app-cells>
      <v-client-table
        :data="table_medication.items"
        :columns="table_medication.columns"
        :options="table_medication.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader_medication }"
      >
        <template #name="{ row }">{{ row.public_name }}</template>
        <template #category="{ row }">{{ row.item?.category?.name || '-' }}</template>
        <template #stock="{ row }">{{ row.stock }}</template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            @input="onClickPagination('pagination_medication', 'fetchItemsMedication', $event)"
            v-if="pagination_medication.pages > 1"
            v-model="pagination_medication.page"
            :page-count="pagination_medication.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_medication.count" :count="table_medication.items.length" :page="pagination_medication.page" :limit="40" />
      </app-cells>
      <app-cells><h2 class="title">Equipment</h2></app-cells>
      <v-client-table
        :data="table_equipment.items"
        :columns="table_equipment.columns"
        :options="table_equipment.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader_equipment }"
      >
        <template #number="{ row }">{{ row.number }}</template>
        <template #name="{ row }">{{ row.public_name }}</template>
        <template #status="{ row }">
        <span :style="{ 'backgroundColor': row.status.color }" class="status-tag">
          {{ row.status.name }}
        </span>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            @input="onClickPagination('pagination_equipment', 'fetchItemsEquipment', $event)"
            v-if="pagination_equipment.pages > 1"
            v-model="pagination_equipment.page"
            :page-count="pagination_equipment.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_equipment.count" :count="table_equipment.items.length" :page="pagination_equipment.page" :limit="40" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import {
  getStorageItemsBulkMedications,
  getStorageItemsBulkMedicalEquipment
} from '@/http'

export default {
  name: 'StorageMedicationEquipment',
  data() {
    return {
      page_loaded: false,
      table_medication: {
        items: [],
        columns: [
          'name',
          'category',
          'stock',
        ],
        options: {
          headings: {
            'name': 'Name',
            'category': 'Category',
            'stock': 'Stock',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_medication: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader_medication: false,
      table_equipment: {
        items: [],
        columns: [
          'name',
          'category',
          'stock',
        ],
        options: {
          headings: {
            'name': 'Name',
            'category': 'Category',
            'stock': 'Stock',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_equipment: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader_equipment: false,
    }
  },
  created() {
    Promise.all([
      this.fetchItemsEquipment(),
      this.fetchItemsMedication()
    ])
      .then(() => {
        this.page_loaded = true
      })
  },
  methods: {
    async fetchItemsEquipment() {
      this.table_preloader_trackable = true
      const response = await getStorageItemsBulkMedicalEquipment({
        page: this.pagination_equipment.page,
        page_size: 40,
      })
      this.table_equipment.items = response.data.results
      this.pagination_equipment.pages = response.data.pages
      this.pagination_equipment.count = response.data.count
      this.table_preloader_trackable = false
    },
    async fetchItemsMedication() {
      this.table_preloader_bulk = true
      const response = await getStorageItemsBulkMedications({
        page: this.pagination_medication.page,
        page_size: 40,
      })
      this.table_medication.items = response.data.results
      this.pagination_medication.pages = response.data.pages
      this.pagination_medication.count = response.data.count
      this.table_preloader_bulk = false
    },
    onClickPagination(pagination, action, page) {
      this[pagination].page = page
      this[action]()
    },
  }
}
</script>
